import wx from './wx';
import qq from './qq';
import { TGetGps } from './types';
import qs from 'qs';
import { Platform } from '@/utils/Platform';
import { DEFAULT_GPS } from '@/const';

const { doNotGetLC } = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});

let adaptor: TGetGps;
if (Platform.is('WeChat') && !Platform.is('WeChatWork')) {
  adaptor = wx;
} else {
  if (doNotGetLC) {
    adaptor = () => {
      return Promise.resolve(
        JSON.parse(
          localStorage.getItem('store_gps') || JSON.stringify(DEFAULT_GPS),
        ),
      );
    };
  } else {
    adaptor = qq;
  }
}

export default adaptor;
// {lat,lng,province,city,district}
